import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom'; // Router debe envolver la aplicación
import { AuthProvider } from './context/AuthContext'; // AuthProvider debe estar dentro del Router

const container = document.getElementById('root');
const root = createRoot(container); // Creamos el "root"

root.render(
  <Router> {/* Asegúrate de que el Router esté aquí */}
    <AuthProvider> {/* AuthProvider va dentro del Router */}
      <App />
    </AuthProvider>
  </Router>
);
